import { createAxiosClient } from "@ntg/component-library/utilities";

export interface IBomLineD365 {
    dataAreaId: string;
    lineCreationSequenceNumber: number;
    bomId: string;
    itemNumber: string;
    consumptionWarehouseId: string;
    consumptionSiteId: string;
    productUnitSymbol: string;
    lineType: string;
    flushingPrinciple: string;
    vendorAccountNumber: string;
    routeOperationNumber: number;
    quantity: number;
}

export const getBomLinesByBomD365 = async (
    bomId: string,
    dataAreaId: string,
): Promise<IBomLineD365[]> => {
    const axiosAuth = createAxiosClient("D365FO");
    const response = await axiosAuth.get<IBomLineD365[]>(
        `/BomLine/GetBomLinesByBomD365`,
        { params: { bomId, dataAreaId } },
    );
    return response.data ?? [];
};
